/**
 * Sensible defaults for quick agent creation when user skips advanced provider pickers.
 */
export const QUICK_AGENT_PROVIDER_DEFAULTS = {
  aiProvider: 'openai',
  aiModel: 'gpt-4o-mini',
  sttProvider: 'deepgram',
  sttModel: 'nova-2',
  voiceProvider: 'deepgram',
  voiceId: 'aura-asteria-en',
  sttLanguage: 'en',
  enableTranscriptions: true,
  enableRecording: false,
  havePresetQuestions: false,
  presetQuestions: [],
  repromptMessage: "I didn't hear you. Could you please repeat?",
  ttsConfig: { engine: 'neural' },
};

export function buildQuickAgentPayload(formFields) {
  return {
    ...QUICK_AGENT_PROVIDER_DEFAULTS,
    ...formFields,
    customUseCase: formFields.customUseCase || '',
    isRootAgent: false,
  };
}
